module.exports = __webpack_public_path__ + "assets/5522ba9d7ff24c64df432d76ef4f61de.png";